module.exports = __webpack_public_path__ + "img/horizontal_4_3_r_pp3_0.aeca02a0.png";